module.exports = __webpack_public_path__ + "img/入库剪影@2x.67b1ecbb.png";